'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _canUseDom = require('can-use-dom');

var _canUseDom2 = _interopRequireDefault(_canUseDom);

var _FacebookProvider = require('./FacebookProvider');

var _FacebookProvider2 = _interopRequireDefault(_FacebookProvider);

var _getCurrentHref = require('./utils/getCurrentHref');

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Share = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Share, _Component);

  function Share() {
    var _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Share);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onClick = function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(evn) {
        var popup, facebook, _this$props, _this$props$href, href, display, _this$props$appId, appId, hashtag, redirectURI, quote, mobileIframe, fb, response, _this$props2, children, onResponse;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                evn.preventDefault();
                evn.stopPropagation();

                popup = _this.props.popup;

                if (!popup) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', _this.openPopup(evn));

              case 5:
                facebook = _this.context.facebook;
                _this$props = _this.props, _this$props$href = _this$props.href, href = _this$props$href === undefined ? (0, _getCurrentHref2.default)() : _this$props$href, display = _this$props.display, _this$props$appId = _this$props.appId, appId = _this$props$appId === undefined ? facebook.props.appId : _this$props$appId, hashtag = _this$props.hashtag, redirectURI = _this$props.redirectURI, quote = _this$props.quote, mobileIframe = _this$props.mobileIframe;
                _context.next = 9;
                return facebook.init();

              case 9:
                fb = _context.sent;
                _context.next = 12;
                return fb.ui({
                  method: 'share',
                  href: href,
                  display: display,
                  app_id: appId,
                  hashtag: hashtag,
                  redirect_uri: redirectURI,
                  quote: quote,
                  mobile_iframe: mobileIframe
                });

              case 12:
                response = _context.sent;
                _this$props2 = _this.props, children = _this$props2.children, onResponse = _this$props2.onResponse;

                if (children && children.props && children.props.onClick) {
                  children.props.onClick(evn);
                }

                if (onResponse) {
                  onResponse(response);
                }

                return _context.abrupt('return', response);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Share.prototype.componentDidMount = function componentDidMount() {
    var popup = this.props.popup;

    if (_canUseDom2.default && !popup) {
      this.context.facebook.init();
    }
  };

  Share.prototype.openPopup = function openPopup(evn) {
    var href = this.getSharerHref();
    var _props = this.props,
        width = _props.width,
        height = _props.height;


    var halfWidth = Math.floor(width / 2);
    var halfHeight = Math.floor(height / 2);

    var left = Math.floor(window.innerWidth / 2 - halfWidth);
    var top = Math.floor(window.innerHeight / 2 - halfHeight);

    var params = 'status=0, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0';

    window.open(href, 'sharer', params);

    var children = this.props.children;

    if (children && children.props && children.props.onClick) {
      children.props.onClick(evn);
    }
  };

  Share.prototype.getSharerHref = function getSharerHref() {
    var facebook = this.context.facebook;
    var _props2 = this.props,
        _props2$href = _props2.href,
        href = _props2$href === undefined ? (0, _getCurrentHref2.default)() : _props2$href,
        display = _props2.display,
        _props2$appId = _props2.appId,
        appId = _props2$appId === undefined ? facebook.props.appId : _props2$appId,
        hashtag = _props2.hashtag,
        redirectURI = _props2.redirectURI,
        quote = _props2.quote,
        mobileIframe = _props2.mobileIframe;


    return '//www.facebook.com/dialog/share?' + _qs2.default.stringify({
      href: href,
      display: display,
      app_id: appId,
      hashtag: hashtag,
      redirect_uri: redirectURI,
      quote: quote,
      mobile_iframe: mobileIframe
    });
  };

  Share.prototype.render = function render() {
    var _props3 = this.props,
        children = _props3.children,
        render = _props3.render,
        Component = _props3.component;


    if (render) {
      return render({
        onClick: this.onClick
      });
    }

    if (Component) {
      return _react2.default.createElement(Component, { onClick: this.onClick });
    }

    return (0, _react.cloneElement)(children, {
      onClick: this.onClick
    });
  };

  return Share;
}(_react.Component), _class.contextTypes = (0, _extends3.default)({}, _FacebookProvider2.default.childContextTypes), _class.propTypes = {
  href: _propTypes2.default.string,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.node,
  hashtag: _propTypes2.default.string,
  quote: _propTypes2.default.string,
  mobileIframe: _propTypes2.default.bool,
  display: _propTypes2.default.string.isRequired,
  appId: _propTypes2.default.string,
  redirectURI: _propTypes2.default.string,
  render: _propTypes2.default.func,
  component: _propTypes2.default.node,
  popup: _propTypes2.default.bool,
  onResponse: _propTypes2.default.func
}, _class.defaultProps = {
  href: undefined,
  children: undefined,
  hashtag: undefined,
  quote: undefined,
  mobileIframe: undefined,
  display: 'popup',
  width: 626,
  height: 436,
  buttonClassName: 'btn btn-lg',
  iconClassName: 'fa fa-facebook pull-left',
  icon: true,
  appId: undefined,
  redirectURI: undefined,
  render: undefined,
  component: undefined,
  popup: false,
  onResponse: undefined
}, _temp2);
exports.default = Share;


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/Share.js
// module id = 688
// module chunks = 1